import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    (async () => {
      try {
        const u = await api("/auth/session", { method: "POST", body: { session_id: sid } });
        setUser(u);
        toast.success(`Bentornato${u.name ? ", " + u.name.split(" ")[0] : ""}!`);
        const next = sessionStorage.getItem("auth_next") || "/";
        sessionStorage.removeItem("auth_next");
        window.history.replaceState(null, "", window.location.pathname);
        navigate(next, { replace: true });
      } catch {
        toast.error("Accesso non riuscito. Riprova.");
        navigate("/accedi", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-base flex flex-col items-center justify-center gap-4">
      <Loader2 className="animate-spin text-forest-glow" size={32} />
      <p className="text-cement text-sm">Accesso in corso...</p>
    </div>
  );
}
